/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at

 * http://www.apache.org/licenses/LICENSE-2.0

 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export function requestAnimationFrame (fn: (params: any) => any): number {
  if (window.requestAnimationFrame == null) {
    return window.setTimeout(fn, 20)
  }
  return window.requestAnimationFrame(fn)
}

export function cancelAnimationFrame (id: number): void {
  if (window.cancelAnimationFrame == null) {
    window.clearTimeout(id)
  }
  window.cancelAnimationFrame(id)
}
